import styled from 'styled-components';
import { Autocomplete } from '@attain-sre/attain-design-system';

export const SearchArea = styled.div`
  position: sticky;
  top: 64px;
  z-index: 999;
  background: white;
  padding: 16px;
  border-bottom: 1px solid rgb(205, 199, 209);

  display: flex;
  flex-wrap: wrap;
  align-items: center;

  > * {
    flex-shrink: 0;
  }
`;

export const SelectAutoCompletePlatform = styled(Autocomplete)`
  width: 170px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const SegmentName = styled.div`
  margin-left: 0px;
  font-size: 16px;
  max-width: 350px;
  white-space: nowrap;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  cursor: pointer;
  font-family: Calibre-Regular, sans-serif;
`;

export const NumberCell = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const CurrencyCell = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const LastUpdated = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const SearchTextField = styled.div`
  width: 300px;
  margin-right: 10px;
`;

export const SelectAutoCompleteGroupOptions = styled.li`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  word-break: break-all;
`;

export const LastSyncedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
`;

export const LastSyncedLabel = styled.div`
  font-size: 14px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
  line-height: 16px;
  margin-bottom: 2px;
`;

export const LastSyncedDate = styled.div`
  font-size: 16px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  line-height: 16px;
`;

export const LastSyncedTime = styled.div`
  font-size: 16px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  line-height: 16px;
`;
